/** Hidden honeypot field — catches bots, invisible to humans */
export default function NewsletterHoneypot({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <input
      type="text"
      name="website"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      tabIndex={-1}
      autoComplete="off"
      className="absolute opacity-0 pointer-events-none h-0 w-0"
      aria-hidden="true"
    />
  );
}
